import { render, staticRenderFns } from "./LehrgangsuebergreifendeNotenuebersicht.vue?vue&type=template&id=b26aebfe&"
import script from "./LehrgangsuebergreifendeNotenuebersicht.vue?vue&type=script&lang=js&"
export * from "./LehrgangsuebergreifendeNotenuebersicht.vue?vue&type=script&lang=js&"
import style0 from "./LehrgangsuebergreifendeNotenuebersicht.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports